module.exports = __webpack_public_path__ + "static/img/point-icon-img@m.81e6fb1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/ing-life/point-icon-img@m.png
// module id = d6QM
// module chunks = 0